import { render } from "./partnerSeats.vue?vue&type=template&id=cc15260a&ts=true"
import script from "./partnerSeats.vue?vue&type=script&lang=ts"
export * from "./partnerSeats.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__